// Utils
import cn from '@/utils/cn';

// Types
import { TitleType } from '@/types/TitleType';

// Styles
import styles from './MixedTitle.module.css';

interface MixedTitleProps {
  title: TitleType['title'];
  seoTitleTag: TitleType['seoTitleTag'];
  size: TitleType['size'];
  color: TitleType['color'];
  sizeSpan: TitleType['sizeSpan'];
  colorSpan?: TitleType['colorSpan'];
  className?: string;
}

function MixedTitle({
  title,
  seoTitleTag = 'h2',
  size,
  color,
  sizeSpan = null,
  colorSpan = null,
  className = '',
}: MixedTitleProps) {
  const Component = seoTitleTag;

  return (
    <Component
      className={cn([
        styles.title,
        styles[color],
        styles[size],
        sizeSpan ? styles[`script_${sizeSpan}`] : null,
        colorSpan ? styles[`script_${colorSpan}`] : null,
        className,
      ])}
      dangerouslySetInnerHTML={{ __html: title }}
    />
  );
}

export default MixedTitle;
